'use es6';

import * as api from './api';
import { resolveExposures } from './utils';
import { ensureFn, filterObject } from './helpers';
import { validateWithDefaults } from './validators';
import { DEBUG_MESSAGES } from '../messages';
export function logError(...err) {
  ensureFn(console.error)(...err);
}
export function logWarning(...warn) {
  ensureFn(console.warn)(...warn);
}
export function createDebugLogger({
  debug
}) {
  const debugLogger = (message = '', caller = 'createDebugLogger') => {
    if (typeof message === 'function') {
      return console.debug(`[laboratory-lib "${caller}"] ${message()}`);
    }

    if (typeof message === 'object') {
      return console.debug(`[laboratory-lib "${caller}"]`, message);
    }

    return console.debug(`[laboratory-lib "${caller}"] ${message}`);
  };

  return {
    logDebug: ensureFn(debug && debugLogger)
  };
}
export function createExposureLogger({
  apiDomain,
  http,
  identifiers,
  resolveTreatments,
  onError,
  logDebug
}) {
  const commonParams = {
    apiDomain,
    http,
    onError,
    logDebug,
    query: filterObject(Object.assign({}, identifiers))
  };
  const validators = validateWithDefaults(onError, 'createExposureLogger');

  const logExposures = treatmentOrKeys => {
    const result = validators.validateExposures(treatmentOrKeys);
    resolveTreatments(treatments => {
      const exposures = resolveExposures({
        treatments,
        treatmentOrKeys: result.treatmentOrKeys
      });
      return api.logExposures(Object.assign({}, commonParams, {
        exposures
      })).then(() => {
        // If the amount of supposedly exposed treatments is different from the "valid" ones
        // Then it means that some of those treatments should not be exposed and we should debug that
        if (exposures.length < result.treatmentOrKeys.length) {
          ensureFn(logDebug)(DEBUG_MESSAGES.exposureFailed, 'createExposureLogger');
        }
      });
    });
  };

  return {
    logExposures,
    logExposure: treatmentOrKey => // This method should not be called without arguments or with a falsy value
    logExposures(treatmentOrKey ? [treatmentOrKey] : undefined)
  };
}